import { EditOutlined } from '@ant-design/icons'
import { flatNodes, type ViewConfigSheet, ViewConfigSheetValueObject } from '@salescore/core'
// eslint-disable-next-line sonarjs/deprecation
import { SqlSyntaxHighlighter, useModal } from '@salescore/frontend-common'
import { Button, Form, Modal } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { t } from 'i18next'
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'

import { kpiFormAtom } from '../../../../recoil/view/atoms'
import { useCurrentSheet } from '../../../../recoil/view/selectors/kpiFormSelector'
import { updateMetricFormValue } from '../../../../recoil/view/util'
import { MeasureCustomSqlEditor } from '../../../../rsheet/components/editor/MeasureCustomSqlEditor'

// eslint-disable-next-line sonarjs/prefer-read-only-props
export function KpiFormMeasureCustomSqlEditor({
  setFormModified,
}: {
  /** KPIの変更フラグを立てる */
  setFormModified: (modify: boolean) => void
}) {
  const [form, setForm] = useRecoilState(kpiFormAtom)
  const currentSheet = useCurrentSheet()
  const sheet = new ViewConfigSheetValueObject(currentSheet)
  // eslint-disable-next-line sonarjs/deprecation
  const modal = useModal()
  const measure = form.metricFormValue?.measure
  const [formInstance] = useForm()
  useEffect(() => {
    if (measure?.type === 'kpiCustom' && (measure.sql === undefined || measure.sql === '')) {
      modal.showModal()
    }
  }, [measure?.type])
  if (measure?.type !== 'kpiCustom') {
    return <></>
  }

  return (
    <>
      <div>
        <SqlSyntaxHighlighter sql={measure.sql ?? ''} onClick={modal.showModal} />
        <div className="flex w-full flex-row-reverse">
          <Button type="text" icon={<EditOutlined />} className="text-blue-500" onClick={modal.showModal}>
            {t(`SQLを編集`)}
          </Button>
        </div>
      </div>
      <Modal
        width={'90%'}
        open={modal.isModalVisible}
        destroyOnHidden
        onOk={() => {
          formInstance.submit()
          setFormModified(true)
        }}
        onCancel={modal.hideModal}
      >
        <Form<{ sql: string }>
          form={formInstance}
          initialValues={{ sql: measure.sql ?? `COUNT(*)` }}
          onFinish={(value) => {
            // eslint-disable-next-line sonarjs/todo-tag
            // TODO: SQLが正しいかチェックしたい
            setForm((oldValue) =>
              updateMetricFormValue(oldValue, {
                measure: {
                  type: 'kpiCustom',
                  sql: value.sql === '' ? undefined : value.sql,
                  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                  dependentNodeNames: getDependentNodeNames(value.sql ?? ``, sheet.config.tree),
                },
              }),
            )
            modal.hideModal()
          }}
        >
          <MeasureCustomSqlEditor sheetConfig={currentSheet} />
        </Form>
      </Modal>
    </>
  )
}

function getDependentNodeNames(sql: string, configTree: ViewConfigSheet['tree']): string[] {
  if (configTree === undefined) {
    // ありえないはず
    return []
  }
  const nodes = flatNodes(configTree)
  const nodeNames = nodes.map((x) => x.name)
  return nodeNames.filter((nodeName) => sql.includes(nodeName)) // 「名前が含まれてれば使っている」という雑な計算を行う
}
